import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type Props = {
	children: ReactNode;
};

export const ChartLegend = ({ children }: Props) => (
	<ChartLegendContainer>{children}</ChartLegendContainer>
);

export default ChartLegend;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLegendContainer = styled.div({
	display: 'flex',
	flexDirection: 'row',
	paddingLeft: token('space.400', '32px'),
	margin: `${token('space.300', '24px')} 0 ${token('space.150', '8px')} ${token('space.500', '40px')}`,
});
